import { ITEM_TYPES } from "../../item/item-types"
import { MESSAGE_TYPES } from "../../item/message-types"
import { AbstractChatMessage } from "./abstract-chat-message"

export class ChatMessage extends AbstractChatMessage{
    constructor(){
        super()
        this.setType(MESSAGE_TYPES.Chat)
    }
    setContent(content: string){
        this.content = content
    }
    hasContent(): boolean {
        return this.content.length > 0 
    }
    getContentString(): string {
        return this.content.title;
    }
}

interface ChatMessageContent {
    message: string;
}